import React, { useId, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon } from 'lucide-react';
import { searchProducts, fromPrice, productPath } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
import type { Line, Product } from '../../types/product';
type SearchBoxProps = {
  onNavigate?: () => void;
  autoFocus?: boolean;
  line?: Line;
};
export function SearchBox({
  onNavigate,
  autoFocus,
  line = 'beauty'
}: SearchBoxProps) {
  const id = useId();
  const [query, setQuery] = useState('');
  const [focused, setFocused] = useState(false);
  const navigate = useNavigate();
  const results = searchProducts(query, 6, line);
  const showPanel = focused && query.trim().length > 0;
  const living = line === 'living';
  const go = (p: Product) => {
    navigate(productPath(p));
    setQuery('');
    setFocused(false);
    onNavigate?.();
  };
  return <form role="search" className="relative w-full" onSubmit={e => {
    e.preventDefault();
    if (results[0]) go(results[0]);
  }} data-id="element-284" data-mp="11vxtwreaskhj">
      <label htmlFor={id} className="sr-only" data-id="element-285" data-mp="xgbnbn9915qm">Zoek producten</label>
      <SearchIcon className={`pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted ${living ? 'left-4' : 'left-0'}`} aria-hidden="true" data-id="element-286" data-mp="12gpl8ch4yzax" />
      <input id={id} type="search" value={query} autoComplete="off" autoFocus={autoFocus} onChange={e => setQuery(e.target.value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onKeyDown={e => e.key === 'Escape' && setFocused(false)} placeholder={living ? 'Zoek theeglazen, khamsa, Safi-borden…' : 'Zoek arganolie, savon beldi, kessa…'} className={living ? 'h-12 w-full rounded-lg border border-line bg-stone pl-11 pr-14 text-sm text-ink placeholder:text-muted focus:border-majorelle focus:bg-white focus:outline-none' : 'h-10 w-full border-b border-ink/15 bg-transparent pl-7 pr-2 text-sm text-ink placeholder:text-muted focus:border-ink focus:outline-none'} data-id="element-287" data-mp="si0dhciyev8e" />
      {living && <button type="submit" className="absolute right-1.5 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-md bg-ink text-white transition-colors duration-150 hover:bg-majorelle" aria-label="Zoeken" data-id="element-288" data-mp="1xo8eh23apboh">
          <SearchIcon className="h-4 w-4" data-id="element-289" data-mp="2leugabmphzq1" />
        </button>}
      {showPanel && <div className="absolute inset-x-0 top-full z-50 mt-2 overflow-hidden rounded-xl border border-line bg-white shadow-[0_16px_40px_-16px_rgba(20,20,20,0.25)]" data-id="element-290" data-mp="2ghvqu6dzmgy6">
          {results.length === 0 ? <p className="px-4 py-5 text-sm text-muted" data-id="element-291" data-mp="27f30c5cmq99e">Geen producten gevonden voor “{query}”.</p> : <ul data-id="element-292" data-mp="111n7werwckct">
              {results.map(p => <li key={p.slug} data-id="element-293" data-mp="w18zuwqapaes">
                  <button type="button" onMouseDown={e => e.preventDefault()} onClick={() => go(p)} className="flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors duration-150 hover:bg-surface" data-id="element-294" data-mp="w068knp295yc">
                    <img src={p.image} alt="" className="h-11 w-11 rounded-md bg-surface object-cover" data-id="element-295" data-mp="3gnpqewr8glp7" />
                    <span className="flex-1" data-id="element-296" data-mp="3lh0rsida0a9q">
                      <span className="block text-sm font-medium text-ink" data-id="element-297" data-mp="3qfbzamg3m8os">{p.name}</span>
                      <span className="block text-xs text-muted" data-id="element-298" data-mp="3vdn9iyab2l7j">
                        {p.line === 'living' ? 'AMIRA Living' : 'AMIRA Beauty'} · {p.subtitle}
                      </span>
                    </span>
                    <span className="text-sm font-medium text-ink" data-id="element-299" data-mp="89h6se6ov596">{formatPrice(fromPrice(p))}</span>
                  </button>
                </li>)}
            </ul>}
        </div>}
    </form>;
}